// extracted by mini-css-extract-plugin
export default {"pt0":"World_pt0__4LJrq","worldMapWrapper":"World_worldMapWrapper__eMoeR"};